require('public/assets/css/WalkingTour/v3/common.scss')

import colors from './style/colors'
import fonts from './style/fonts'
import styledlist from './style/styledlist'
import icons from './style/icons'
import navigation from './style/navigation'
import titles from './style/titles'
import buttons from './style/button'
import modals from './style/modal'
import inputfields from './style/inputfield'
import placeholder from './style/placeholder'

const defaults = {
    placeholder: placeholder,
    scrollable: styledlist.scrollable,
    contextMenu: styledlist.contextMenu,
    contextMenuDesktop: styledlist.contextMenuDesktop,
    stopslist: styledlist.stopslist,
    tourslist: styledlist.tourslist,
    colors,
    button: buttons.button,
    rounded: buttons.rounded,
    button_rounded_transparent: buttons.button_rounded_transparent,
    icons,
    fonts,
    navigation,
    titles,
    buttons,
    delay: {
        fast: '250ms',
        normal: '500ms',
        slow: '750ms',
        mainMediaTransition: '1000ms',
        long: '3000ms',
    },
    modals,
    inputfields,
}

defaults.video_button = Object.assign({}, defaults.button, defaults.rounded, {
    padding: 11.5,
    width: 26,
    height: 26,
    background: colors.transparentBlack,
})

defaults.button_orange = Object.assign({}, defaults.button, {
    background: colors.orange,
    borderRadius: 4,
    boxShadow: '0 0.2em 0.4em 0 rgba(0, 0, 0, 0.5)',
})

defaults.shareModalButton = Object.assign({}, defaults.button_orange, {
    width: '100%',
    padding: '0.55em 0',
})
defaults.shareModalButton_label = Object.assign(
    {},
    {
        display: 'block',
        color: '#fff',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: 26,
    }
)

defaults.button_transparent = Object.assign({}, defaults.button, {
    width: '1.1em',
    height: '1.1em',
    background: 'transparent',
})

defaults.button_tourmenu = Object.assign({}, defaults.button_transparent, {
    width: '1.4em',
    height: '0.95em',
})

defaults.button_stopmenu = Object.assign({}, defaults.button_transparent, {
    width: '1.25em',
    height: '0.95em',
    background: 'transparent',
    padding: '1.35em 1.05em 1em 1em',
})

defaults.button_orange_label = defaults.fonts.proximaNova_16

defaults.share_button = Object.assign({}, defaults.button, defaults.rounded, {
    width: '1.15em',
    height: '1.3em',
})
defaults.library_button = Object.assign({}, defaults.button, {
    width: '1.3em',
    height: '1.3em',
    padding: 13,
    background: colors.grey_2,
    borderRadius: 4,
})
defaults.library_button_icon = Object.assign(
    {},
    {
        width: 26,
        height: 26,
    }
)
defaults.hide_library_button = Object.assign({}, defaults.button, {
    width: '1.125em',
    height: '0.695em',
    padding: '19px 14.5px 19.1px 15px',
    background: colors.grey_2,
    borderRadius: 4,
})
defaults.hide_library_button_icon = Object.assign(
    {},
    {
        width: 22.5,
        height: 13.9,
    }
)
defaults.info_button = Object.assign({}, defaults.button, {
    width: '1.5em',
    height: '1.5em',
    padding: 13,
})
defaults.accessible_button_icon = Object.assign({}, defaults.button, {
    width: '1.5em',
    height: '1.5em',
})

defaults.caret_button = Object.assign({}, defaults.button, defaults.rounded, {
    width: '1.1em',
    height: '0.645em',
})
defaults.tour_menu = {
    backgroundImage: colors.grey_2_1_gradient,
    position: 'absolute',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
}

export default defaults
